module.exports = __webpack_public_path__ + "site/img/137.ea4921d1.jpg";